<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
    inactiveOnRoutes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    ...mapActions('appointments', ['fetchAppointments', 'fetchTrackingStatus']),
    ...mapActions('rentalBranch', {
      fetchBookings: 'fetchBookings',
      fetchRentalBranchTracking: 'fetchTrackingStatus',
    }),
    // router-link's isActive is an inclusive prefix match, so a nested route
    // (e.g. real_estate_appointments under /real_estate) would also light up
    // a parent nav item unless explicitly excluded via inactiveOnRoutes.
    isItemActive(isActive) {
      return (
        (isActive && !this.inactiveOnRoutes.includes(this.$route.name)) ||
        this.isChildMenuActive
      );
    },
  },
  data() {
    return {
      rentalBookings: null,
    }
  },
  computed:{
    ...mapGetters('appointments', ['statusCount', 'getTrackingStatus']),
    ...mapGetters('onboarding', ['remainingLocalCount']),
    isAppointment(){
      return this.name === 'APPOINTMENTS';
    },
    isOnboarding(){
      return this.name === 'ONBOARDING';
    },
    isRentalBookings(){
      return this.name === 'RENTAL_BOOKINGS';
    },
    appointmentCount() {
      if (!this.isAppointment || !this.statusCount || !this.getTrackingStatus) return 0;
      return this.statusCount[this.getTrackingStatus] || 0;
    },
    onboardingCount() {
      if (!this.isOnboarding || !this.remainingLocalCount) return 0;
      return this.remainingLocalCount;
    },
    rentalBookingCount() {
      if (!this.isRentalBookings || !this.rentalBookings || !this.$store.state.rentalBranch.trackingStatus) return 0;
      return this.rentalBookings.counts[this.$store.state.rentalBranch.trackingStatus] || 0;
    }
  },
  async mounted(){
    if (this.isAppointment) {
      await this.fetchAppointments();
      await this.fetchTrackingStatus();
    }
    if (this.isRentalBookings) {
      this.rentalBookings = await this.fetchBookings();
      await this.fetchRentalBranchTracking();
    }
  },
}
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right-end="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="text-slate-700 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600 relative"
      :class="{
        'bg-woot-50 dark:bg-slate-800 text-woot-500 hover:bg-woot-50':
          isItemActive(isActive),
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <fluent-icon
        :icon="icon"
        :class="{
          'text-woot-500': isItemActive(isActive),
        }"
      />
      <span class="sr-only">{{ $t(`SIDEBAR.${name}`) }}</span>
      <span
        v-if="count"
        class="text-black-900 bg-yellow-500 absolute -top-1 -right-1"
      >
        {{ count }}
      </span>
      <span
        v-if="isAppointment && appointmentCount >= 0"
        class="text-center text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ appointmentCount }}
      </span>
      <span
        v-if="isOnboarding && onboardingCount >= 0"
        class="text-center text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ onboardingCount }}
      </span>
      <span
        v-if="isRentalBookings && rentalBookingCount >= 0"
        class="text-center text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ rentalBookingCount }}
      </span>
    </a>
  </router-link>
</template>
